import { Navigate } from "react-router-dom";
import { useEffect, useState } from "react";
import api from "@/lib/api";

export default function ProtectedRoute({ children }) {
  const [state, setState] = useState("checking");
  useEffect(() => {
    const token = localStorage.getItem("admin_token");
    if (!token) return setState("nope");
    api
      .get("/auth/me")
      .then(() => setState("ok"))
      .catch(() => {
        localStorage.removeItem("admin_token");
        setState("nope");
      });
  }, []);
  if (state === "checking")
    return (
      <div
        style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", color: "var(--mute)" }}
      >
        <span className="mono-eyebrow">Loading…</span>
      </div>
    );
  if (state === "nope") return <Navigate to="/admin/login" replace />;
  return children;
}
